/**
 *
 * @name getProviderOptions
 * @param {array} providers
 * @description
 * Опции для react-select
 *
 * @returns {*[]|*}
 */
export const getProviderOptions = (providers) => {
  if (providers) {
    return providers
      .filter((provider) => provider.import)
      .map((provider) => ({
        label: provider.name,
        value: provider.id,
      }))
  }
  return [];
};

/**
 * @getProviderValue
 * @param providers
 * @param providerId
 * @description
 * value для react select
 *
 * @returns {null|{label: *, value: *}}
 */
export const getProviderValue = (providers, providerId) => {
  if (providers && providerId) {
    const findProvider = providers.find((provider) => Number(provider.id) === Number(providerId));
    if (findProvider) {
      return {
        label: findProvider.name,
        value: findProvider.id,
      }
    }
  }
  return null;
}

/**
 *
 * @name isEmptyServices
 * @param {array} services
 * @description
 * Проверка наличия сервисов в кагоерии
 *
 * @returns {boolean}
 */
export const isEmptyServices = (services) => !!services;

/**
 *
 * @name checkingOptions
 * @param {object} options
 * @description
 * Опции для импорта
 *
 * @returns {boolean}
 */
export const checkingOptions = (support_copy_descriptions) => !!support_copy_descriptions;

/**
 *
 * @returns {[{accessKey: string, title: string, value: number}, {accessKey: string, title: string, value: number}, {accessKey: string, title: string, value: number}]}
 */
export const getActionsList = () => [
  {
    title: 'Create category',
    accessKey: 'create_category',
    value: -1,
  },
  {
    title: 'Assign to category',
    accessKey: 'assign_to_category',
    value: 1,
  },
  {
    title: 'Not assigned',
    accessKey: 'not_assigned',
    value: 0,
  },
]

export const splitToRows = (list) => {
  if (list) {
    const row = [];
    list.forEach((category, categoryIndex) => {
      row.push({
        ...category,
        collection: 'category',
      });

      if (category.collapsed) {
        return;
      }

      category.services.forEach((service, serviceIndex) => {
        row.push({
          ...service,
          categoryIndex,
          serviceIndex,
          collection: 'service',
        })
      })
    })
    return row;
  }
  return null;
};
